import dayjs from "dayjs";
import numeral from "numeral";

export const formatDate = (dateString, format = "YYYY-MM-DD") => {
  if (!dateString) return "";

  const dateFormatString = dayjs(dateString).format(format);

  if (dateFormatString === "Invalid Date") return "";

  return dateFormatString;
};

export const formatPrice = (priceString, decimal = "") => {
  return numeral(priceString.toLocaleLowerCase()).format(`0,0${decimal}`);
};

export const formatTruncate = (str, length = 5) =>
  str.length > length ? `${str?.substring(0, length)}...` : str;
